
export type MarkNotificationAsDelivered200BasicInfoType = typeof MarkNotificationAsDelivered200BasicInfoType[keyof typeof MarkNotificationAsDelivered200BasicInfoType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MarkNotificationAsDelivered200BasicInfoType = {
  LIKE: 'LIKE',
  REPLY: 'REPLY',
  RETWEET: 'RETWEET',
  FOLLOW: 'FOLLOW',
  MENTION: 'MENTION',
} as const;
